import { FunctionComponent, useEffect, useState } from "react";
import { Modal } from "antd";
import { ReactComponent as LightOn } from "src/static/images/light-on.svg";
import { CloseOutlined } from "@ant-design/icons";
import { FaqResponseDto } from "@state/em_faq/dto/faq.response.dto";
import { requestGetFaq } from "@state/em_faq/EMFaqEffects";
import FaqAccordions from "@components/accordions/FaqAccordions";
import { useTranslation } from "react-i18next";

interface FaqModalProps {
  category?: string;
  visible: boolean;
  onOk?: () => void;
  onCancel: () => void;
  className?: string;
  type: "farmer" | "collectivity";
}

const FaqModal: FunctionComponent<FaqModalProps> = ({
  category,
  visible,
  onOk,
  onCancel,
  className = "",
  type,
}) => {
  const { t } = useTranslation();

  const [faq, setFaq] = useState<FaqResponseDto[]>([]);

  useEffect(() => {
    if (category && visible) requestGetFaq(category);
  }, [visible, category]);

  useEffect(() => {
    return requestGetFaq.done.watch(({ result }) => {
      if (result.ok && result.data) {
        setFaq(result.data);
      }
    });
  });

  return (
    <>
      <Modal
        centered
        title={null}
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        className={`app-modal faq-modal ${className}`}
        closable={false}
        footer={null}
        zIndex={10000}
      >
        <button className="close-button" onClick={onCancel}>
          <CloseOutlined size={48} />
        </button>
        <div className="faq-modal-container">
          {category && (
            <div className="faq-modal-title">
              <LightOn aria-hidden="true" focusable="false" />
              <h2 className="title">{t(`faq.${category}.title`)}</h2>
            </div>
          )}
          <div className="disclaimer">{t(`results.disclaimer-${type}`)}</div>
          <FaqAccordions faq={faq} />
        </div>
      </Modal>
    </>
  );
};

export default FaqModal;
